module.exports = __webpack_public_path__ + "static/img/empty-shop-product-list.e6eab445.png";